import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/sample_transport_kit',
  title: 'Kits',
  endpoint: '/app/sample_transport_kit',
  breadcrumbs: [],
}
